/* Избор на вариант по опции.
   Комбинацията от избраните стойности се сравнява с вариантите на продукта.

   Последната редица е „редицата с офертите“ — там всяка карта показва
   собствената си цена, зачеркнатата цена и колко се спестява. Цените се
   изчисляват спрямо това, което е избрано в другите редици. */
(function () {
  'use strict';

  function money(cents, format) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, v);
    }
    return v + ' €';
  }

  function init(root) {
    var sections = (root || document).querySelectorAll('[data-lp-pick]');
    Array.prototype.forEach.call(sections, function (sec) {
      if (sec.dataset.lpPickOn === '1') return;
      sec.dataset.lpPickOn = '1';

      var dataEl = sec.querySelector('[data-lp-pick-data]');
      var form   = sec.querySelector('.lp-pick__form');
      if (!dataEl || !form) return;

      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var cta     = form.querySelector('[data-lp-pick-cta]');
      var idInput = form.querySelector('[data-lp-pick-id]');
      var groups  = form.querySelectorAll('[data-lp-pick-option]');
      var summary = form.querySelector('[data-lp-pick-summary]');
      var wasEl   = form.querySelector('[data-lp-pick-was]');
      var nowEl   = form.querySelector('[data-lp-pick-now]');
      var saveEl  = form.querySelector('[data-lp-pick-save]');
      if (!cta || !idInput || !groups.length) return;

      var offerRow = groups.length - 1;
      if (groups.length > 1) form.classList.add('lp-pick--has-offers');
      groups[offerRow].classList.add('lp-pick__group--offers');

      function chosen() {
        var out = [];
        Array.prototype.forEach.call(groups, function (g, i) {
          var r = g.querySelector('.lp-pick__radio:checked');
          out[i] = r ? r.value : null;
        });
        return out;
      }

      function findVariant(sel) {
        if (sel.indexOf(null) !== -1) return null;
        for (var i = 0; i < data.variants.length; i++) {
          var v = data.variants[i];
          var hit = true;
          for (var j = 0; j < sel.length; j++) {
            if (v.options[j] !== sel[j]) { hit = false; break; }
          }
          if (hit) return v;
        }
        return null;
      }

      /* Всяка карта в редицата с офертите показва своята цена. */
      function paintOffers() {
        var sel = chosen();
        var cards = groups[offerRow].querySelectorAll('.lp-pick__card');

        Array.prototype.forEach.call(cards, function (card) {
          var radio = card.querySelector('.lp-pick__radio');
          var box   = card.querySelector('[data-lp-pick-card-money]');
          var now   = card.querySelector('[data-lp-pick-card-now]');
          var was   = card.querySelector('[data-lp-pick-card-was]');
          var save  = card.querySelector('[data-lp-pick-card-save]');
          if (!radio || !box) return;

          var trial = sel.slice();
          trial[offerRow] = radio.value;

          // Другите редици още не са избрани — цената не може да се покаже.
          for (var i = 0; i < trial.length; i++) {
            if (i !== offerRow && trial[i] === null) { box.hidden = true; return; }
          }

          var v = findVariant(trial);
          if (!v) { box.hidden = true; card.classList.add('is-unavailable'); return; }

          card.classList.toggle('is-unavailable', !v.available);
          box.hidden = false;
          now.textContent = money(v.price, data.money_format);

          if (v.compare_at_price > v.price) {
            was.textContent = money(v.compare_at_price, data.money_format);
            was.hidden = false;
            if (save) {
              save.textContent = 'Спестявате ' + money(v.compare_at_price - v.price, data.money_format);
              save.hidden = false;
            }
          } else {
            was.hidden = true;
            if (save) save.hidden = true;
          }
        });
      }

      function sync() {
        paintOffers();

        var v = findVariant(chosen());

        if (!v) {
          idInput.value = '';
          cta.disabled = true;
          cta.textContent = cta.dataset.idle;
          if (summary) summary.hidden = true;
          return;
        }

        idInput.value = v.id;

        if (summary) {
          summary.hidden = false;
          nowEl.textContent = money(v.price, data.money_format);
          if (v.compare_at_price > v.price) {
            wasEl.textContent = money(v.compare_at_price, data.money_format);
            wasEl.hidden = false;
            var pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
            saveEl.textContent = '−' + pct + '%';
            saveEl.hidden = false;
          } else {
            wasEl.hidden = true;
            saveEl.hidden = true;
          }
        }

        if (v.available) {
          cta.disabled = false;
          cta.textContent = cta.dataset.ready;
        } else {
          cta.disabled = true;
          cta.textContent = cta.dataset.sold;
        }
      }

      form.addEventListener('change', function (e) {
        if (e.target.classList.contains('lp-pick__radio')) sync();
      });

      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
